export const convertEuro = num => {
  return num ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(num) : '€0,00';
}
